<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 96 960 960">
    <title>Vai</title>
    <path
      d="m375 816-43-43 198-198-198-198 43-43 241 241-241 241Z"
      fill="#11181C"
    />
  </svg>
</template>

<script>
export default {};
</script>
